import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  impersonated: false,
  superadmin: null,
  publisherData: null
};

const impersonationSlice = createSlice({
  name: 'impersonation',
  initialState,
  reducers: {
    setSessionDetails: (state, action) => {
      state.impersonated = false;
      state.superadmin = null;
      state.publisherData = action.payload.publisherData || null;
    },
    setImpersonation: (state, action) => {
      state.impersonated = true;
      state.superadmin = action.payload.superadmin || null;
      state.publisherData = action.payload.publisherData || null;
    },
    clearImpersonation: (state) => {
      state.impersonated = false;
      state.superadmin = null;
      state.publisherData = null;
    }
  }
});

export const { setSessionDetails, setImpersonation, clearImpersonation } = impersonationSlice.actions;
export default impersonationSlice.reducer;
